import * as React from 'react';
import {
  CssBaselineContext,
  ICssBaseLineTheme,
  ICssBaseline,
} from './CssBaseline.context';
import { JssProvider, jss } from 'react-jss';
import { useRootContext } from '../Root/Root.context';
import clsx from 'clsx';
import useStyles from './CssBaseline.styles';

interface ICssBaselineInternalProps {
  shadow?: boolean;
  theme: ICssBaseLineTheme;
  children: React.ReactNode;
}

const CssBaselineInternal: React.FC<ICssBaselineInternalProps> = ({
  shadow,
  theme,
  children,
}) => {
  const classes = useStyles();

  return (
    <CssBaselineContext.Provider value={{ theme }}>
      <div
        className={clsx(
          shadow && classes.shadow,
          classes[theme],
          classes.default,
        )}
      >
        {children}
      </div>
    </CssBaselineContext.Provider>
  );
};

const CssBaseline: React.FC<React.PropsWithChildren<ICssBaseline>> = ({
  children,
  theme,
}) => {
  const rootContext = useRootContext();

  return rootContext ? (
    <JssProvider
      jss={jss.setup({
        insertionPoint: rootContext?.node || document.head,
      })}
    >
      <CssBaselineInternal shadow={Boolean(rootContext?.node)} theme={theme}>
        {children}
      </CssBaselineInternal>
    </JssProvider>
  ) : (
    <CssBaselineInternal theme={theme}>{children}</CssBaselineInternal>
  );
};

export default CssBaseline;
